import {
  DOCUMENT,
  Inject,
  Injectable,
  Renderer2,
  RendererFactory2,
} from "@angular/core";
import { GoogleTagManagerService } from "angular-google-tag-manager";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class GTMService {
  private renderer: Renderer2;

  constructor(
    private gtmSer: GoogleTagManagerService,
    renderFActory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = renderFActory.createRenderer(null, null);
  }

  public loadGTM(): void {
    if (!environment.gtmKey) return;

    // Inject <script> into <head>
    const script = this.renderer.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${environment.gtmKey}`;
    this.renderer.appendChild(this.document.head, script);

    // Inject <noscript> into <body>
    const noscript = this.renderer.createElement("noscript");
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${environment.gtmKey}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    this.renderer.appendChild(this.document.body, noscript);
  }

  signupCompleted() {
    const dataLayer: Ecommerce = this.getData();

    const tag = {
      event: "rs.signup",
      ...dataLayer,
    };

    console.log("---TAG", tag);
    this.gtmSer.pushTag(tag);
  }

  private getData(): Ecommerce {
    const payloadRaw = sessionStorage.getItem("signupPayload");
    const payload = payloadRaw ? JSON.parse(payloadRaw) : null;

    const totalProp = payload?.metadata?.property?.find(
      (item: { key: string; value: string }) => item.key === "totalAmount"
    );
    const totalAmount = totalProp ? Number(totalProp.value) : 0;

    const order = payload?.order || {};

    return {
      ecommerce: {
        currencyCode: payload?.currencyCode ?? "",
        purchase: {
          actionField: {
            id: order?.id ?? "", // ✅ prevents reading undefined.id
            affiliation: payload?.geography ?? "",
            revenue: totalAmount,
          },
          products: order?.item ?? [],
        },
      },
    };
  }
}

export interface Ecommerce {
  ecommerce: {
    currencyCode?: string;
    purchase: {
      actionField: {
        id?: string;
        affiliation?: string;
        revenue?: number;
      };
      products?: [];
    };
  };
}